import { type ReactNode } from 'react'
import {
  useSection,
  Section,
  SectionHeader,
  SectionTitleSuffix,
  SectionContent,
} from '@/components/Section'
import { TableHead, TableHeader, TableBody } from '@/components/Table'
import { Button } from '@/components/Button'
import styles from './ItemsBreakdownSection.module.css'
import { ServiceTableHeader } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/ServiceTableHeader'
import { ScopeChangeRequestBreakdownTable } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ItemsSection/components/ScopeChangeRequestBreakdownTable'

export interface ItemsBreakdownSectionProps {
  title: string
  itemColumnTitle: string
  isExpanded: boolean
  onToggleExpanded: () => void
  count: number
  showEditButton?: boolean
  onEdit?: () => void
  children?: ReactNode
}

export function ItemsBreakdownSection({
  title,
  itemColumnTitle,
  isExpanded,
  onToggleExpanded,
  count,
  showEditButton,
  onEdit,
  children,
}: ItemsBreakdownSectionProps) {
  const sectionProps = useSection(false)

  return (
    <Section
      {...sectionProps}
      collapsed={!isExpanded}
      onToggleCollapse={onToggleExpanded}
    >
      <SectionHeader borderless>
        <div className={styles.headerContainer}>
          <div>
            {title} <SectionTitleSuffix>({count})</SectionTitleSuffix>
          </div>
          {showEditButton && (
            <div className={styles.editButton}>
              <Button label="Edit" variant="text" onPress={onEdit} />
            </div>
          )}
        </div>
      </SectionHeader>
      <SectionContent>
        <ScopeChangeRequestBreakdownTable>
          <TableHead className={styles.tableHead}>
            <TableHeader className={styles.quantityTableHeader} />
            <ServiceTableHeader align="left">
              {itemColumnTitle}
            </ServiceTableHeader>
            <ServiceTableHeader align="right">Client fee</ServiceTableHeader>
            <ServiceTableHeader align="right">Pro cut</ServiceTableHeader>
          </TableHead>
          <TableBody>{children}</TableBody>
        </ScopeChangeRequestBreakdownTable>
      </SectionContent>
    </Section>
  )
}
